import highchartsVersion from './highchartsVersion';
import filterOptionsForSize from './filterOptionsForSize';
import processData from './processData';
import processCategories from './processCategories';
import processSeries from './processSeries';
import { processStyles } from '../style/';
import merge from 'lodash.merge';
import isPlainObject from 'lodash.isplainobject';

export default function processOptions(options, Highcharts) {
  removeOldProperties(options);
  options = copyOptions(options, Highcharts);
  options = filterOptionsForSize(options);
  options = processData(options);
  options = processCategories(options);
  options.styles = processStyles(options);
  options = processSeries(options);
  options.el = containerElement(options.el);
  //new added propeerties are handled here
  addNewProperties(options);
  return options;
}

function removeOldProperties(options){
  //if layout is bottom make it default;
  if(options.legend.layout === 'bottom') {
    options.legend.layout = 'default';
  };
}

function copyOptions(options, Highcharts) {
  return  merge({}, {
    HIGHCHARTS_VERSION: highchartsVersion(Highcharts),
    id: options.el.getAttribute('id') || options.size,
  }, options);
}

// Prepares the container DOM element.
function containerElement(el) {
  el = (typeof el === 'string') ? document.querySelector(el) : el;
  if (!el.querySelector('div.dj-chart-container')) {
    let divA = document.createElement('div');
    let divB = document.createElement('div');
    divA.className = 'dj-chart-container';
    divB.className = 'dj-chart-inner';
    el.appendChild(divA);
    el.appendChild(divB);
  }
  return el;
}

function addNewProperties(options){
  //promo fields
  options.headings.sourcePromo = options.headings.sourcePromo ? options.headings.sourcePromo : {text: options.headings.source.text, enabled: true};
  options.headings.notePromo = options.headings.notePromo ? options.headings.notePromo : {text: options.headings.note.text, enabled: true};
  options.headings.subdekPromo = options.headings.subdekPromo ? options.headings.subdekPromo : {text: options.headings.subdek.text, enabled: true};
  //plot lines
  options.plotLines = options.plotLines ? options.plotLines :
  [{ plotLineValue: '',
    plotLineDashStyle: 'solid',
    plotLineLabel: '',
    plotLineLabelPosition: 'top right',
    plotLineColor: '' }];
  //allowDecimals yAxis
  options.allowDecimals = options.allowDecimals === undefined ? true : options.allowDecimals;
}


// WEBPACK FOOTER //
// ./src/chart/data/processOptions.js